module.exports = __webpack_public_path__ + "img/mine-title-logo.8b9bd4d8.png";